module.exports = __webpack_public_path__ + "img/icon_5_14.c5742f48.png";